import { useTranslation } from 'react-i18next';
import { useUserGeneratedContent } from '../../../../models/user-generated-contents/context';
import {
  PlainEditor,
  PlainEditorProps,
} from '../../../../components/ui/plain-editor';
import { MAXIMUM_TITLE_LENGTH } from '../../../../models/user-generated-contents/context';
import '../form.scss';

const trackingContext: PlainEditorProps['trackingContext'] = {
  contentSection: 'title',
};

const TitleInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
  } = useUserGeneratedContent();
  const { t } = useTranslation();

  const onTextChange = (title: string) => {
    updateUserGeneratedContentFormState({ title });
  };

  return (
    <PlainEditor
      className={'ugc-editor'}
      aria-label={t('user_generated_content.field_title')}
      disabled={isPersisting}
      defaultValue={userGeneratedContent.title || ''}
      maximumCharacter={MAXIMUM_TITLE_LENGTH}
      onChange={onTextChange}
      placeholder={t('user_generated_content.field_title_placeholder')}
      trackingContext={trackingContext}
    />
  );
};

export default TitleInput;
